import { List, ListItem } from '@mui/material';
import { ReactNode } from 'react';

export const DvsErrors = ({ detailNodes }: Readonly<{ detailNodes: ReactNode[] }>) => {
  return (
    <List>
      {detailNodes.map((detailNode, index) => (
        <ListItem key={index}>{detailNode}</ListItem>
      ))}
    </List>
  );
};
